import { PayloadAction } from "@reduxjs/toolkit";
import { MoneyState } from "../../models/MoneyState";
import { GetCategoriesPayload } from "../../payload/GetCategories/GetCategoriesPayload";

const getCategoriesFetch = (state: MoneyState, action: PayloadAction<GetCategoriesPayload>) => {
    state.isLoading = true;
}

export default getCategoriesFetch;